<template>
  <div>
    <div class="mask"></div>
    <div class="fullview">
      <div class="loading-spacer"></div>
      <vue-loading
        type="spiningDubbles"
        color="#5cd5d6"
        :size="{ width: '50vw' }"
      />
      <p class="text">通信中です</p>
    </div>
  </div>
</template>

<script>
import { VueLoading } from "vue-loading-template";

export default {
  name: "loading",
  components: {
    VueLoading,
  },
};
</script>

<style lang="scss" scoped>
.mask {
  z-index: 10000;
  width: 100%;
  height: 100%;
  background: black;
  position: fixed;
  top: 0;
  left: 0;
  opacity: 0.7;
}

.fullview {
  z-index: 10000;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;

  .text {
    color: #8cecec;
    position: absolute;
    text-align: center;
    top: calc(35vh + (44vw / 2));
    left: 50vw;
    transform: translate(-50%, -50%);
  }

  .loading-spacer {
    height: 35vh;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Organisms/MiniLoading.vue